var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon[data-v-6b6aae5a],.news-notify[data-v-6b6aae5a]{display:-webkit-box;display:-ms-flexbox;display:flex}.icon[data-v-6b6aae5a]:before{content:\"\";display:inline-block;height:20px;width:20px;-webkit-transition:background .25s ease-out;transition:background .25s ease-out}.icon--info[data-v-6b6aae5a]:before{background:url(" + escape(require("../../assets/img/icon-info-active.svg")) + ") no-repeat 50%}", ""]);

// exports
